import { Tooltip } from "antd";
import { StatusDay, Type } from "./styles";
import { MdWarning } from "react-icons/md";
import { ColumnType } from "antd/lib/table";
import { formatarData } from "../../utils";

const columns = (tipoPlanejamento: number): ColumnType<any>[] => {
  let columnsShow: ColumnType<any>[] = [
    {
      title: "Seq.",
      dataIndex: "index",
      align: "center",
      width: 60,
      render: (value: number) => <span style={{ fontSize: 13 }}>{value}</span>,
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      render: (value: string) => <span style={{ fontSize: 13 }}>{value}</span>,
    },
    {
      title: "Planejamento Inicial",
      dataIndex: "dataProgramada",
      align: "center",
      width: 220,
      render: (value: string, dataValue: any) => {
        const dataInicio = dataValue?.periodoDataInicio;
        const dataFim = dataValue?.periodoDataFim;

        if (dataInicio && dataFim) {
          return (
            <span style={{ fontSize: 13 }}>
              {formatarData(dataInicio)} à {formatarData(dataFim)}
            </span>
          );
        }

        return (
          <span style={{ fontSize: 13 }}>
            {value ? formatarData(value) : "-"}
          </span>
        );
      }
    },
    {
      title: "Data Ajustada",
      dataIndex: "dataAjustada",
      align: "center",
      width: 135,
      render: (value: string) => <span style={{ fontSize: 13 }}>{value ? formatarData(value) : "-"}</span>,
    },
    {
      title: "Data Executada",
      dataIndex: "dataExecucao",
      align: "center",
      width: 135,
      render: (value: string) => <span style={{ fontSize: 13 }}>{value ? formatarData(value) : "-"}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      width: 150,
      render: (status: string) => {
        let color: string = "#ddd";
        if (status.toLocaleLowerCase() === "planejada") {
          color = "#3498db";
        } else if (status.toLocaleLowerCase() === "executada") {
          color = "#27ae60";
        } else if (status.toLocaleLowerCase() === "executadaparcialmente") {
          color = "#f39c12";
        } else if (status.toLocaleLowerCase() === "atrasada") {
          color = "#e74c3c";
        }
        return (
          <span style={{ fontSize: 13 }}>
            <Type color={color}>{status}</Type>
          </span>
        )
      },
    },
    {
      title: "Dias Diferença",
      dataIndex: "quantidadeDias",
      width: 120,
      align: "center",
      render: (value: number, dataValue: any) => {
        const newValue = Math.abs(value);
        const dataCal = dataValue.dataAjustada ?? dataValue.dataProgramada;
        const typePlan = tipoPlanejamento === 1 ? "Inicial" : "Ajustado";
        let valueStr: any = newValue;
        let textTooltip = "";
        let str = "";

        if (dataValue.status === "Planejada" && newValue === 0) {
          str = "N/A";
          valueStr = "";
        }
        if (dataValue.status === "Executada" || dataValue.status === "ExecutadaParcialmente") {
          textTooltip = `Executado (${formatarData(dataValue.dataExecucao)}) - Planejamento ${typePlan} (${formatarData(dataCal)}) = ${newValue} dia(s)`;
        } else if (dataValue.status === "Atrasada") {
          textTooltip = `Data Atual (${new Date().toLocaleDateString('pt-BR', { timeZone: 'UTC' })}) - Planejamento ${typePlan} (${formatarData(dataCal)}) = ${newValue} dia(s)`;
        }
        let textFinal = `${str} ${valueStr} dia(s)`;
        return (
          <Tooltip title={value ? textTooltip : undefined}>
            <StatusDay warning={newValue > 0}>
              {newValue > 0 && <MdWarning />} {value ? textFinal : "-"}
            </StatusDay>
          </Tooltip>
        )
      },
    },
  ];

  return columnsShow;
}

export default columns;
